import React from 'react'
import Toggles from './Toggles'

import { useSelector, useDispatch } from 'react-redux'
import { SET_HELPERS } from '../Redux/Actions/Helpers/HelpersActionTypes'
import { Link } from 'react-router-dom'

import Click from '../Sounds/Click.mp3'
import { Howl } from 'howler'
import styled from 'styled-components'

const Nav = styled.nav`
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: var(--main-color);
    border-bottom: .2em solid black;
    height: 6em;
    &.glass {
        background: rgba( 255, 255, 255, 0.25 );
        backdrop-filter: blur( .4em );
        -webkit-backdrop-filter: blur( .4em );
        border-bottom: .2em solid transparent;
        border-radius: 2em;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 5px 15px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
        p {
            color: black;
        }
        div {
            &:hover {
                text-shadow: none;
                color: var(--main-color);
            }
        }
    }
`
const IconContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: .3s;
    &:hover {
        cursor: pointer;
        transform: scale(1.10);
        text-shadow: 3px 5px 8px black;
    }
`
const Caption = styled.p`
    font-size: 1.4em;
    color: #FFFFFF;
    margin-left: .5em;
    @media (max-width: 900px) {
        display: none;
    }
`
const Icon = styled.img`
    height: 2.5em;
    width: 2.5em;
    padding: .5em;
    border-radius: 50%;
    background: white;
    &.sound {
        cursor: pointer;
        margin-right: 1em;
    }
`

const SoundAndToggles = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`

const NavBar = () => {

    const dispatch = useDispatch()

    const style = useSelector(state => state.themes.style)
    const playSounds = useSelector(state => state.helpers.playSounds)

    const handleSounds = () => {
        dispatch({
            type: SET_HELPERS,
            payload: {
                playSounds: !playSounds,
            }
        })
    }

    const click = new Howl({
        src: [Click],
        volume: 0.25,
        mute: !playSounds
    })

    return (
        <>
            <Nav className={(style === 'glass' ? 'glass' : '')}>
                <Link to='/home' style={{ textDecoration: 'none'}}>
                    <IconContainer onClick={() => click.play()}>
                        <Icon src='https://api.iconify.design/ant-design:home-filled.svg'/>
                        <Caption>Home</Caption>
                    </IconContainer>
                </Link>
                {/* <Link to='/home' style={{ textDecoration: 'none'}}>
                    <IconContainer onClick={() => {
                        click.play()
                        alert('Under development')
                        }}>
                        <Icon src='https://i.imgur.com/EAuw8J0.png'/>
                        <Caption>Search</Caption>
                    </IconContainer>
                </Link> */}
                <Link to='/team' style={{ textDecoration: 'none'}}>
                    <IconContainer onClick={() => click.play()}>
                        <Icon src='https://i.imgur.com/q5o0NkA.png'/>
                        <Caption>Captures</Caption>
                    </IconContainer>
                </Link>
                {/* <Link to='/home' style={{ textDecoration: 'none'}}>
                    <IconContainer onClick={() => {
                        click.play()
                        alert('Under development')
                        }}>
                        <Icon src='https://i.imgur.com/89MydrR.png'/>
                        <Caption>Battle</Caption>
                    </IconContainer>
                </Link> */}
                <Link to='roulette' style={{ textDecoration: 'none'}}>
                    <IconContainer onClick={() => click.play()}>
                        <Icon src='https://api.iconify.design/ion:dice-sharp.svg'/>
                        <Caption>Roulette</Caption>
                    </IconContainer>
                </Link>
                <Link to='/about' style={{ textDecoration: 'none'}}>
                    <IconContainer onClick={() => click.play()}>
                        <Icon src='https://api.iconify.design/heroicons-solid:users.svg'/>
                        <Caption>About</Caption>
                    </IconContainer>
                </Link>
                <SoundAndToggles>
                    {playSounds ? (
                        <Icon onClick={() => handleSounds()} className="sound" src='https://i.imgur.com/qIsf9Kl.png'/>
                    ) : (
                        <Icon onClick={() => handleSounds()} className="sound" src='https://i.imgur.com/GwR3fGG.png'/>
                    )}
                    <div>
                        <Toggles/>
                    </div>
                </SoundAndToggles>
            </Nav>
        </>
    )
}

export default NavBar
